<template>
    <div>
        <div>
            <h3>รายงานผลการคำนวณการเข้างาน <br> แสดงตามพนักงาน</h3>
            <br/>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>ตั้งแต่วันที่</label>
                </b-col>
                <b-col sm="6">
                    <date-picker
                        v-model="form.start_date"
                        :not-after="currentDate"
                        placeholder="เลือกวันที่"
                        :format="changeFormat"
                        :lang="lang" confirm>
                    </date-picker>
                </b-col>
            </b-row>
            <br/>
            <b-row sm="10">
                <b-col sm="4" class="col text-right">
                    <label>ถึง</label>
                </b-col>
                <b-col sm="6">
                    <date-picker
                        v-model="form.end_date"
                        :not-before="form.start_date"
                        :not-after="currentDate"
                        placeholder="เลือกวันที่"
                        :format="changeFormat"
                        :lang="lang" confirm>
                    </date-picker>

                </b-col>
            </b-row>
            <br/>
        </div>
        <div class="col text-center">
            <button @click="submitData"
                    type="button"
                    class="btn btn-primary">
                <icon name="print" style="width: 25px"></icon>
                พิมพ์
            </button>&nbsp;&nbsp;
            <button @click="cancelData"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <!--        <pre class="alert-primary">{{optionEmployee}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import moment from "moment";

export default {
    name: "import-work-time-pdf-modal",
    props: {
        optionEmployee: {default: Array}
    },
    created() {
        this.getCurrentDate();
    },
    data() {
        return {
            currentDate: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    components: {
        Multiselect,
        DatePicker,
    },
    computed: {
        ...mapState({
            form: (state) => {
                return state.ScanEmployee.form_PDF;
            },
        })

    },
    methods: {
        submitData() {
            if (!this.form.start_date) {
                alert('กรุณาเลือกวันที่เริ่มต้น')
            } else if (!this.form.end_date) {
                alert('กรุณาเลือกวันที่สิ้นสุด')
            } else {
                this.form.start_date = moment(this.form.start_date).format("YYYY-MM-DD");
                this.form.end_date = moment(this.form.end_date).format("YYYY-MM-DD");

                this.$emit("submit", this.form);
            }
        },
        cancelData() {
            this.$emit("submit", 0);
        },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
        },
    }
}
</script>

<style scoped>

</style>
